// extracted by mini-css-extract-plugin
export default {"dropdownControlsPanel":"ElementSelector_dropdownControlsPanel__q5zii","selectorColumn":"ElementSelector_selectorColumn__CYMLx"};